import React, { useEffect, useState } from "react";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import {
  SideBarActiveDiv,
  SideBarNormalDiv,
  SideBarNormalDivButton,
  SideBarActiveDivButtonNew,
  SideBarNormalDivButtonNew,
  SideBarActiveCount,
  SideBarNormalCount,
} from "../../pages/Theme";

const SidebarItemNew = ({
  items,
  isLast,
  setSelectedOption,
  selectedOption,
  isJournal,
  isShared,
  valueId,
  isAnnounce,
  isFeed,
  isShowcaseGallery,
}) => {
  const [sidebar, setSidebar] = useState(items.open);
  const showSidebar = () => setSidebar(!sidebar);

  const Tab = ({ text, active, ...props }) => {
    let style = "font-14px font-medium cursor-pointer hover:text-blue-500";
    return active ? (
      // <SideBarNormalDiv className={style}>
      //     {text}
      // </SideBarNormalDiv> :
      <SideBarActiveDiv className={style}>{text}</SideBarActiveDiv>
    ) : (
      <SideBarNormalDiv className={style}>{text}</SideBarNormalDiv>
    );
  };

  useEffect(() => {
    if (valueId) {
      if (items.item.some((item1) => item1.id === valueId)) {
        setSidebar(true);
      }
    }
  }, [valueId]);

  return (
    <div className={` ${isLast ? "" : " border-bottom-f1 "} pb-3 pt-3`}>
      <div
        className="flex  items-center justify-between cursor-pointer "
        onClick={showSidebar}
      >
        {isShared ? (
          <>
            {/* <div onClick={() => { setSelectedOption(""); }}> */}
            <Tab
              text={items.title}
              active={items.item.some(
                (item1) => item1.id === selectedOption.value
              )}
            />
            {/* </div> */}
            {sidebar ? (
              <MdKeyboardArrowDown
                className="blueColor flex flex-shrink-0"
                size={20}
              />
            ) : (
              <MdKeyboardArrowRight
                className="blueColor flex flex-shrink-0"
                size={20}
              />
            )}
          </>
        ) : (
          <>
            <Tab
              text={items.title}
              active={items.item.some(
                (item1) => item1.id === selectedOption.value
              )}
            />
            {sidebar ? (
              <MdKeyboardArrowDown
                className="blueColor w-max flex flex-shrink-0"
                size={20}
              />
            ) : (
              <MdKeyboardArrowRight
                className="blueColor flex flex-shrink-0"
                size={20}
              />
            )}
          </>
        )}
      </div>
      <div className="flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2">
        {sidebar &&
          (items.item.length > 0 ? (
            items.item.map((item, index) =>
              selectedOption.value == item.id ? (
                <SideBarActiveDivButtonNew
                  type="button"
                  className="font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium"
                  key={index}
                  value={item.id}
                  onClick={() => setSelectedOption(item.id)}
                >
                  <span className="flex-1 mr-1 break-anywhere">
                    {item.value}
                  </span>
                  {(isJournal ||
                    isShared ||
                    isFeed ||
                    isAnnounce ||
                    isShowcaseGallery) && (
                    <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                      {item.count}
                    </SideBarActiveCount>
                  )}
                </SideBarActiveDivButtonNew>
              ) : (
                <SideBarNormalDivButtonNew
                  type="button"
                  className="font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium"
                  key={index}
                  value={item.id}
                  onClick={() => setSelectedOption(item.id)}
                >
                  <span className="flex-1 mr-1 break-anywhere">
                    {item.value}
                  </span>
                  {(isJournal ||
                    isShared ||
                    isFeed ||
                    isAnnounce ||
                    isShowcaseGallery) && (
                    <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                      {item.count}
                    </SideBarNormalCount>
                  )}
                </SideBarNormalDivButtonNew>
              )
            )
          ) : (
            <>
              <span className="flex items-center py-2 text-sm greyColor">
                No Items
              </span>
            </>
          ))}
      </div>
    </div>
  );
};

export default SidebarItemNew;
